import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
} from "react";
import { useNavigate } from "react-router-dom";
import { Button, Container, Dialog, Stack, Typography } from "@mui/material";


import { API_Subscriber, APIs_selectClient, API_Client } from "../App/api.jsx";
import { AccordianGrid, AccordionSet } from "../Components/AccordianGrid.jsx";
import AddClient from "../App/AddClient.jsx";
import ToggleSet from "../Components/ToggleSet.jsx";
import {
  getOptions,
  postOptions,
  deleteOptions,
  empty_uuid,
  ftchPlus,
  FtchPlusError,
  clientScenOption,
  UrlOptions,
  AddQueryString,
} from "../App/Account_urls.jsx";

import { useClient } from "../App/useClient.jsx";
import { CopyIconRenderer, DeleteIconRenderer, EditIconRenderer, NameSpouseRenderer, ScenarioIconRenderer, ViewIconRenderer, WhoWhenRenderer } from "../App/GridRenderers.jsx";
import { WhoWhenFormatter } from "../App/GridFormatters.jsx";
import { ErrorBar } from "../Components/ErrorBar.jsx";
import DialogDelete from "../Components/DialogDelete.jsx";
import { Help_selectClient } from "../Dialogs/Help/Help_Select.jsx";
import { QuickStart } from "../Dialogs/Accounts/QuickEntry.jsx";
import { useAuth } from "../App/useAuth.jsx";
import { InputCheck } from "../Components/Inputs/Input_Check.jsx";

const setClientSet = (c, s) => {
  var cs = [];
  if (c !== undefined && c !== null && c !== "") {
    cs.push(c);
  }
  if (s !== undefined && s !== null && s !== "") {
    cs.push(s);
  }
  console.log("setClients");
  console.log(cs);
  return cs;
};



const CopyClientOptions = ({ show,
  accountType,
  options,
  onClose,
  item = "",
  onChangeOptions,
  onCopy,
  onCancel = null }) => {



  const myCancel = () => {
    if (onCancel !== null) {
      onCancel()
    }
    onClose()
  }

  const myCopy = () => {
    onCopy()
    onClose()
  }

  return (
    <>
      {show !== "" && (
        < Dialog
          sx={{
            overflow: "scroll",
            "& .MuiDialog-container": {
              display: "inline-flex !important",
              width: "100%",
            },
          }}

          width="60%"
          maxWidth="100%"
          open={show}
          onClose={onClose}
        >
          <Stack spacing={5} sx={{ mx: 10, mb: 10 }}>
            <Typography sx={{ mx: 10, pt: 10, display: "flex", justifyContent: "center", }} id="delete" variant="h6" gutterBottom>
              Copy Client
            </Typography>
            <Stack spacing={1}>

              <InputCheck
                label="Restricted, ie: will not use up a client license"
                tooltip={"Will not be able to create new accounts or change rules, in the base client or any scenarios copied"}
                name="restricted"
                value={options.restricted}
                onChange={onChangeOptions}
              />
              <InputCheck
                label="Copy all scenarios"
                tooltip={"bascially a full copy of the client and all its data and scenarios, uncheck if you only want the base client information/accounts/rules"}
                name="scenarios"
                value={options.scenarios}
                onChange={onChangeOptions}
              />
              {accountType === "shared" &&
                <InputCheck
                  label="Maintain PII"
                  tooltip={"maintain any Personally Identifying Information (last Name, phone number, email, address, etc"}
                  name="maintainPII"
                  value={options.maintainPII}
                  onChange={onChangeOptions}
                />
              }
            </Stack>
            <Stack sx={{ px: 10, mx: 10, justifyContent: "center" }} direction="row" spacing={10} >
              <Button
                variant="contained"
                onClick={myCopy}
                style={{ display: "block", textAlign: "center", textTransform: 'capitalize', }}          >
                <Typography variant="b1" >Copy {accountType} client {item} </Typography>
                <Typography variant="b1" >To a personal Client </Typography>
              </Button>

            </Stack>
            <Button
              variant="contained"
              color="secondary"
              onClick={myCancel}>
              Cancel
            </Button>
          </Stack>

        </Dialog >
      )}
    </>
  )
}

const ClientSelect = ({ clientJson, c_callback }) => {
  const navigate = useNavigate();
  const { clientJson_r, setclient_ } = useClient();
  const { admin_r } = useAuth();
  const [admin] = useState(admin_r.current)

  const [client, setClient] = useState(
    clientJson && clientJson.name ? clientJson.name : null
  );
  const [clients, setClients] = useState(
    setClientSet(clientJson.name, clientJson.spouseName)
  );

  const [entitlement, setEntitlement] = useState({
    AddClientsDisabled: false
  })
  const [scenarioClients, setScenarioClients] = useState([]);
  const [personal, setPersonal] = useState([]);
  const [shared, setShared] = useState([]);
  const [publicc, setPublicc] = useState([]);
  const icon = useRef();
  const [errmsg, setErrmsg] = useState("")
  const [diaDelete, setDiaDelete] = useState(false)
  const [refetch, setRefetch] = useState(0)
  const [quickStartShow, setQuickStartShow] = useState(false)
  const [diaCopy, setDiaCopy] = useState("");
  const [clientOptions, setClientOptions] = useState({
    restricted: false,
    scenarios: false,
    maintainPII: false,
  })
  const [openAccordion, setOpenAccordion] = useState("0")




  const myChangeClientOptions = (n, v) => {
    let no = {
      ...clientOptions,
      [n]: v,
    };
    setClientOptions(no)
  }

  const DoEdit = () => {
    console.log("edit and show");
    handleShow();
  };

  const okDelete = async () => {
    console.log("delete: " + clientJson_r.current.uuid);
    console.log(clientJson_r.current);
    console.log(clientJson);
    var url = API_Client + clientJson_r.current.uuid;
    ftchPlus(url, deleteOptions)
      .then((json) => {
        console.log("did delete ");

        let nf = {
          ...clientJson,
          uuid: empty_uuid,
          s_uuid: empty_uuid,
          name: "",
          spouseName: "",
        };
        c_callback(nf);
        setClients(setClientSet("", ""))
        setRefetch(refetch + 1)
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
        FtchPlusError(error)
      });
  };


  const okClone = async (accountType) => {
    console.log("clone: " + clientJson_r.current.uuid);
    console.log(clientJson_r.current);

    let url = API_Client + clientJson_r.current.uuid + "/clone";
    let q = ""
    console.log(clientOptions)
    if (clientOptions.scenarios) {
      q = AddQueryString(q, "scenarios=true")
    }
    if (clientOptions.restricted) {
      q = AddQueryString(q, "restricted=true")
    }
    if (clientOptions.maintainPII) {
      q = AddQueryString(q, "maintainPII=true")
    }
    url = UrlOptions(clientJson, url, q)

    ftchPlus(url, postOptions)
      .then((json) => {
        console.log("did clone ");
        setRefetch(refetch + 1)
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
        FtchPlusError(error)
      });
  };



  // consuming Grid Event
  const cellClickedListener = (accountType, e) => {
    console.log(e);
    let c_uuid = e.data.Uuid;
    let c_name = e.data.FullName;
    let s_name = e.data.Spouse;
    let s_uuid = e.data.UuidSpouse;
    let locked = e.data.Locked;

    console.log(e.data);

    setClients(setClientSet(c_name, s_name));

    setClient(c_name);
    let c_json = {
      public: accountType === "public" ? true : false,
      shared: accountType === "shared" ? true : false,
      readonly:
        accountType === "public" || accountType === "shared" ? true : locked,
      uuid: c_uuid,
      s_uuid: s_uuid,
      name: c_name,
      spouseName: s_name,
      Scenario: {
        uuid: empty_uuid,
        label: "",
        readonly: false,
      },
      Sweep: {
        uuid: empty_uuid,
        label: "",
      },
    };
    console.log(c_json);

    c_callback(c_json);
    setclient_(c_json);
    if (
      e.colDef.headerName === "Use" ||
      e.colDef.headerName === "Edit" ||
      e.colDef.headerName === "Copy" ||
      e.colDef.headerName === "View" ||
      e.colDef.headerName === "Delete" ||
      e.colDef.headerName === "Scenarios"
    ) {
      if (icon.current) {
        console.log(icon.current);

        switch (icon.current) {
          case "go-accounts": {
            console.log("Edit action clicked");
            navigate("/setupAccounts");
            break;
          }
          case "go-scenario": {
            navigate("/scenarioSelect");
            break;
          }
          case "go-incomerules": {
            navigate("/setupIncomeRules");

            break;
          }
          case "go-savingrules": {
            navigate("/setupSavingRules");

            break;
          }

          case "go-to-scenario-latest": {
            console.log("Delete scen latest clicked");
            break;
          }
          case "go-view": {
            DoEdit();
            break;
          }
          case "go-edit": {
            DoEdit();
            break;
          }
          case "go-copy": {

            setDiaCopy(accountType)
            //DoClone(accountType);
            break;
          }
          case "go-delete": {
            setDiaDelete(true)
            break;
          }
        }
      }
    }
  };


  // consuming Grid Event
  const cellClickedScenario = (accountType, e) => {
    if (e.colDef.headerName === "Edit") {
      DoEdit();
    }
  };

  const DoDelete = () => {
    okDelete()
  }

  // const cellClickedListenerPublic = (accountType, e) => {
  //   console.log(e);
  //   let c_uuid = e.data.Uuid;
  //   let c_name = e.data.FullName;
  //   let s_name = e.data.Spouse;
  //   let s_uuid = e.data.UuidSpouse;
  //   console.log(e.data);
  //   setClients(setClientSet(c_name, s_name));
  //   setClient(c_name);
  //   let c_json = {
  //     public: true,
  //     shared: false,
  //     uuid: c_uuid,
  //     s_uuid: s_uuid,
  //     name: c_name,
  //     Scenario: {
  //       uuid: empty_uuid,
  //     },
  //     Sweep: {
  //       uuid: empty_uuid,
  //     },
  //   };
  //   console.log(c_json);

  //   c_callback(c_json);
  //   setclient_(c_json);
  //   if (e.colDef.headerName === "View" || e.colDef.headerName === "Action") {
  //     switch (icon.current) {
  //       case "go-edit": {
  //       }
  //       case "go-copy": {
  //         DoClone();
  //         break;
  //       }
  //     }
  //   }
  // };








  const cd_Name = {
    headerName: "Name",
    field: "FullName",
    width: 180,
    cellStyle: { textAlign: "left" },
    filter: "agTextColumnFilter",
    sortable: true,
    // sort: "asc",
    sortIndex: 1,
  };
  const cd_Spouse = {
    headerName: "Spouse",
    field: "Spouse",
    width: 180,
    cellStyle: { textAlign: "left" },
    sortable: true,
    filter: "agTextColumnFilter",
  };
  const cd_NameSpouse = {
    headerName: "Clients",
    field: "",
    width: 180,
    sortable: true,
    cellStyle: { textAlign: "left" },
    cellRenderer: NameSpouseRenderer,
    filter: "agTextColumnFilter",
    sort: "asc",
    sortIndex: 1,
  };

  const cd_Class = {
    headerName: "Class",
    field: "Class",
    cellStyle: { textAlign: "left" },
    sort: "asc",
    sortIndex: 0,
    width: 80,

  };

  const cd_Restricted = {
    headerName: "Restricted",
    field: "Restricted",
    cellStyle: { placeItems: "center" },
    width: 110,
    editable: false,
  };
  const cd_Description = {
    headerName: "Comments",
    field: "AccessDescription",
    cellStyle: { textAlign: "left" },
    width: 800,
  };

  const cd_Created = {
    headerName: "Created",
    field: "Created",
    cellRenderer: WhoWhenRenderer,
    valueFormatter: WhoWhenFormatter,
    // cellStyle: { textAlign: "center", lineHeight: "normal" },
    width: 240,
  };
  const cd_Modified = {
    headerName: "Modified",
    field: "Edited",
    cellRenderer: WhoWhenRenderer,
    valueFormatter: WhoWhenFormatter,

    sortable: true,
    // cellStyle: {
    //   textAlign: "center",
    //   lineHeight: "normal",
    //   verticalAlign: "center",
    // },
    width: 240,
  };
  const cd_ScenarioCount = {
    headerName: "Scenarios",
    field: "ScenarioCount",
    type: "rightAligned",
  };
  const cd_ScenarioRuns = {
    headerName: "Runs",
    field: "ScenarioRuns",
    type: "rightAligned",
  };
  const cd_LastScenario = {
    headerName: "Last Scenario Run",
    field: "Scenario",
    cellRenderer: WhoWhenRenderer,
    valueFormatter: WhoWhenFormatter,
    //cellStyle: { textAlign: "center", lineHeight: "normal" },
    width: 240,
  };

  const onClickDefEdit = (params) => {
    console.log(params);
  };
  const cd_Copy = {
    headerName: "Copy",
    field: "",
    cellRenderer: CopyIconRenderer,
    cellRendererParams: {
      callback: (e) => { icon.current = e },
      value: true,
    },
    width: 70


  };
  const cd_View = {
    headerName: "View",
    field: "",
    cellRenderer: ViewIconRenderer,
    cellRendererParams: {
      callback: (e) => { icon.current = e },
      value: true,
    },
    width: 70
  };
  const cd_Scenarios = {
    headerName: "Scenarios",
    field: "",
    cellRenderer: ScenarioIconRenderer,
    cellRendererParams: {
      callback: (e) => { icon.current = e },
      value: true,
    },
    width: 105,
    // maxWidth: 100,
  };
  const cd_Edit = {
    field: "",
    headerName: "Edit",
    cellRenderer: EditIconRenderer,
    cellRendererParams: {
      callback: (e) => { icon.current = e },
      value: true,

    },
    width: 70
  };

  const cd_Delete = {
    headerName: "Delete",
    field: "",
    cellRenderer: DeleteIconRenderer,
    cellRendererParams: {
      callback: (e) => { icon.current = e },
    },
    width: 70
  };

  const columnDefsPersonal = [
    cd_Scenarios,
    cd_Edit,
    cd_Name,
    cd_Spouse,
    // cd_ScenarioCount,
    // cd_ScenarioRuns,
    cd_LastScenario,
    cd_Class,
    cd_Restricted,
    cd_Modified,
    cd_Created,
    cd_Copy,
    cd_Delete,
  ];

  const columnDefsScenario = [
    cd_Edit,
    cd_Name,
    cd_Spouse,
  ];

  const columnDefsShared = [
    // cd_Edit,
    cd_NameSpouse,
    cd_Spouse,
    cd_Description,
    cd_Modified,
    cd_Copy,
  ];

  const columnDefsPublic = [
    // cd_Edit,
    cd_NameSpouse,
    cd_Description,
    cd_Modified,
    cd_Copy,
  ];

  const NonNullArray = (v) => {
    return v ? v : []
  }

  const getData = async () => {
    var url = API_Subscriber + APIs_selectClient + clientScenOption(clientJson);
    ftchPlus(url, getOptions)
      .then((json) => {
        console.log(json)
        if (json) {
          console.log(json);
          let pers = NonNullArray(json.Personal)
          if (pers.length === 0) {
            setQuickStartShow(true)
          }
          setEntitlement(json.Entitlement)
          setPersonal(NonNullArray(json.Personal));
          setShared(NonNullArray(json.Shared));
          setPublicc(NonNullArray(json.Public));
          setScenarioClients(NonNullArray(json.ScenarioClients))

        } else {
          console.log("no such data");
        }
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
        FtchPlusError(error)

      });

  };

  // useEffect(() => {
  //   setErrmsg("")
  //   console.log("init Get Data")
  //   getData();
  // }, []);

  useEffect(() => {
    setErrmsg("")
    console.log("refetch Data " + refetch)
    getData();
    // return () => {
    //   console.log("clientSelect Unmounted")

    // }
  }, [refetch]);

  useEffect(() => { }, [client, clients]);

  const joinName = () => {
    return clientJson.name + (clientJson.spouseName !== "" ? "/" + clientJson.spouseName : "")
  }

  // useEffect(() => {
  //   console.log(clientJson.name)
  //   setClients(setClients(clientJson.name, clientJson.spouseName))
  // }, [clientJson]);


  const [show, setShow] = useState(false);

  const handleClose = (json) => {
    setShow(false);
    if (typeof json.name !== "undefined") {
      setClients(setClientSet(json.name, json.spouseName))
      navigate("/setupAccounts");

      // setRefetch(refetch + 1)
    }

  }
  const handleShow = () => setShow(true);


  const handleQuickClose = (json) => {
    setQuickStartShow(false);
    if (typeof json.name !== "undefined") {
      setClients(setClientSet(json.name, json.spouseName))

      let c_json = {
        public: false,
        shared: false,
        readonly: false,
        uuid: json.uuid,
        name: json.name,
        s_uuid: json.spouseUuid,
        spouseName: json.spouseName,
        Scenario: {
          uuid: json.scenarioUuid,
          label: json.scenarioLabel,
          readonly: false,
        },
        Sweep: {
          uuid: empty_uuid,
          label: "",
        },
      };

      console.log(c_json);
      setclient_(c_json);
      c_callback(c_json);
      if (json.scenarioUuid !== empty_uuid) {
        // we ran scenario so show it it was all set above
        navigate("/gridScenario");
      } else {
        // we only saved the info, so refresh the client set
        //setRefetch(refetch + 1)
        navigate("/setupAccounts");

      }
    }

  }

  const CrumbPrefix = () => {
    return clientJson.public
      ? "Public"
      : clientJson.shared
        ? "Shared"
        : clientJson.readonly
          ? "Locked"
          : null;
  };

  const personalAdd = (e) => {
    let c_json = {
      uuid: empty_uuid,
      name: "",
      Scenario: {
        uuid: empty_uuid,
      },
      Sweep: {
        uuid: empty_uuid,
      },
    };
    console.log(c_json);

    c_callback(c_json);
    setclient_(c_json);
    handleShow();
  };

  const myAccordionOpen = (key, state) => {
    if (state) {
      setOpenAccordion(key)
    } else {
      setOpenAccordion("")
    }
  }

  const My_AccordianGrid = ({ type = "Clients", ...otherProps }) => {
    return (
      <AccordianGrid
        type={type}
        onClick_kb={myAccordionOpen}
        openKey={openAccordion}
        {...otherProps}
      />
    )
  }

  return (
    <div style={{ display: "flex" }}>
      <Container maxWidth="true">
        <Stack spacing={2}>
          <Stack direction="row" spacing={2}>
            {CrumbPrefix() && (
              <ToggleSet
                set={[CrumbPrefix()]}
                current={CrumbPrefix()}
              />
            )}
            <ToggleSet set={clients} />
          </Stack>
          <AccordionSet>
            {clientJson.Scenario.uuid !== empty_uuid && (
              <My_AccordianGrid
                eventKey="0"
                name={"Current Scenario: <" + clientJson.Scenario.label + ">"}
                type="Client"
                columnDef={columnDefsScenario}
                cellClickedListener={cellClickedScenario}
                data={scenarioClients}
                add={false}
                accountType="scenario"
                height={100}
                useScenCrumb={true}
                clientJson={clientJson}
                c_callback={c_callback}
              />
            )}
            <My_AccordianGrid
              eventKey={clientJson.Scenario.uuid !== empty_uuid ? "1" : "0"}
              name="Personal"
              columnDef={columnDefsPersonal}
              cellClickedListener={cellClickedListener}
              data={personal}
              add={!entitlement.AddClientsDisabled || admin}
              addClick={personalAdd}
              accountType="personal"
              quickStartOnClick={() => { setQuickStartShow(true) }}

            />
            {/* </Accordion>
          <Accordion defaultActiveKey="0"> */}
            <My_AccordianGrid
              eventKey="2"
              name="Shared"
              columnDef={columnDefsShared}
              data={shared}
              accountType="shared"
            />
            <My_AccordianGrid
              eventKey="3"
              name="Public"
              columnDef={columnDefsPublic}
              data={publicc}
              accountType="public"
            />
          </AccordionSet>
        </Stack>
        <ErrorBar error={errmsg} />
        <Help_selectClient />
      </Container>
      <AddClient
        show={show}
        onClose={handleClose}
        c_uuid={clientJson.uuid}
        clientJson={clientJson}
        c_callback={c_callback}
        scenario={clientJson.Scenario.uuid}
      />
      <QuickStart
        open={quickStartShow}
        onClose={handleQuickClose}
      />
      <DialogDelete
        show={diaDelete}
        onClose={() => setDiaDelete(false)}
        query="Do you wish to delete this client and all its scenarios"
        item={joinName()}
        onDelete={DoDelete}
      />
      <CopyClientOptions
        show={diaCopy !== ""}
        accountType={diaCopy}
        onClose={() => setDiaCopy("")}
        options={clientOptions}
        item={joinName()}
        onChangeOptions={myChangeClientOptions}
        onCopy={() => okClone(diaCopy)}
      />

    </div>

  );
};

export default ClientSelect;
